module.exports = __webpack_public_path__ + "img/Speraker-College 2.076859a8.jpg";